import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-menu-contratos',
  imports: [CommonModule],
  templateUrl: './menu-contratos.component.html',
  styleUrls: ['./menu-contratos.component.css'],
  standalone: true
})
export class MenuContratosComponent {
  constructor(private router: Router) {}

  menuItems = [
    { label: '<strong>Contrato</strong> Individual', icon: 'template1.webp', route: 'individual-form/contract/contract1' },
    { label: '<strong>Acta</strong> de Inicio', icon: 'template2.webp', route: 'individual-form/contract/starup1' },
    { label: '<strong>Acta</strong> de Terminación', icon: 'template3.webp', route: 'individual-form/contract/termination1' }
  ];

  irA(route: string) {
    this.router.navigate([route]);
  }
}
